import Navbar from "../Components/Navbar";
import Title from "./Title";
import SectionStartGallary from "./SectionStartGallary";
import HorizontalScrollGallery from "./HorizontalScrollGallery";
import SectionStartQuote from "./SectionStartQuote";
import HorizontalScrollQuote from "./HorizontalScrollQuote";
import SectionStartProtocol from "./SectionStartProtocol";
import HorizontalScrollProtocol from "./HorizontalScrollProtocol";
import SectionStartOutcome from "./SectionStartOutcome";
import HorizontalScrollOutcome from "./HorizontalScrollOutcome";
import SectionStartCollaboration from "./SectionStartCollaboration";
import Funding from "./Funding";
import EndHomepage from "./EndHomepage";
import Footer from "../Components/Footer";

export default function Homepage(){
    return(
        <div>
            <div className="relative mb-8">
                <div className="fixed top-0 left-0 w-screen z-50">
                    <Navbar/>
                </div>
                <Title />
            </div>
            <SectionStartGallary />
            <HorizontalScrollGallery />
            <SectionStartQuote />
            <HorizontalScrollQuote />
            <SectionStartProtocol />
            <HorizontalScrollProtocol />
            <SectionStartOutcome />
            <HorizontalScrollOutcome />
            <SectionStartCollaboration />
            <Funding />
            <EndHomepage />
            <Footer />
        </div>
    )
}